import React, { useEffect } from "react";
import { HeaderImgSection } from '../../Header/HeaderImgSection'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import slider from '../../../images/WEB DESIGNING/WEB-DESIGNING--1900-220.png'
import sidebar from '../../../images/WEB DESIGNING/Web-Designing1.png'

function WebDesign () {
  useEffect(() => {
    document.title = "Web Design || OZVASERVICE"
 }, []);
  return (
    <>
      <HeaderImgSection title={"Web Design"} hTitle={'Services'} img={slider}></HeaderImgSection>
      <Container className='my-5'>
        <h1 className='text-center text-primary fw-semibold '>Web Design</h1>
        <p className='text-center'>At OZVA SERVICE, we specialize in delivering professional, innovative, and visually compelling website design solutions that captivate users and drive measurable results. Our team of experienced designers is passionate about building user-friendly websites that reflect your brand identity and business goals.</p>


        <Row className='my-5 align-items-center'>
          <Col lg={6} className='mb-lg-0 mb-3'>
            <h2 className='text-dark fw-semibold'>Website Design Company You Can Trust</h2>
            <p>OZVA SERVICE is a reliable and results-driven website design and development company dedicated to crafting tailored digital solutions for businesses of all sizes. Our skilled team of designers, developers, and digital strategists works diligently to create visually stunning and high-performing websites — whether it's a corporate website, e-commerce store, mobile interface, or web application.</p>
            <p>As a full-service website design agency, we go beyond design — we strategize. Our team collaborates closely with clients to understand their target audience, industry landscape, and objectives. Every website we create is unique, fully responsive, SEO-optimized, and built with user engagement in mind.</p>
            <p>We design experiences that are intuitive, impactful, and aligned with your brand vision. Whether you're a startup launching your first site or a large organization seeking a redesign, OZVA SERVICE blends creativity, cutting-edge technology, and strategic thinking to deliver websites that stand out and perform.</p>

          </Col>
          <Col lg={6} className='d-flex justify-content-center align-items-center'>
            <div className="">
              <img src={sidebar} className='img-fluid rounded-2' alt="" />
            </div>
          </Col>
        </Row>

        <h2 className='fw-bold mb-4'>How Can a Website Help Your Business?</h2>
        <ul>
          <li>Your website is often the first touchpoint between your brand and potential customers. A professionally designed site builds trust and encourages engagement from the moment visitors land on your page.</li>
          <li>A modern, well-structured website elevates your brand’s image and strengthens credibility in a competitive market.</li>
          <li>Thoughtful design enhances user experience and leads visitors toward your desired actions — such as making a purchase, booking a service, or reaching out.</li>
          <li>A responsive, SEO-friendly website ensures better search engine rankings and improved reach to your target audience.</li>
          <li>As a 24/7 digital storefront, your website communicates your value proposition, attracts potential customers, and supports ongoing business growth.</li>
        </ul>

      </Container>
    </>
  )
}

export default WebDesign
